import { NgModule } from 'ng-metadata/core';
import {PrmVirtualBrowse} from './virtualBrowse.directive';
import {VirtualBrowseService} from './virtualBrowse.service';
import {PrmVirtualBrowseItem} from './virtualBrowseItem/virtualBrowseItem.directive';
import {PrmVirtualBrowseItemInfo} from './virtualBrowseItemInfo/virtualBrowseItemInfo.directive';
import {VirtualBrowseItemInfoService} from './virtualBrowseItemInfo/virtualBrowseItemInfo.service';
import 'angular-inview';

@NgModule({
    declarations: [
        PrmVirtualBrowse,
        PrmVirtualBrowseItem,
        PrmVirtualBrowseItemInfo
    ],
    providers: [
        VirtualBrowseService,
        VirtualBrowseItemInfoService
    ],
    imports:[
        'angular-inview'
    ]
})
export class VirtualBrowseModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/virtualBrowse/virtualBrowse.module.ts